import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#495A64" }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6944 11.3889H16.1111C17.1543 11.3889 18 10.5432 18 9.5V2.88889C18 1.84568 17.1543 1 16.1111 1H9.5C8.4568 1 7.61111 1.84568 7.61111 2.88889V4.30556M2.88889 18H9.5C10.5432 18 11.3889 17.1543 11.3889 16.1111V9.5C11.3889 8.4568 10.5432 7.61111 9.5 7.61111H2.88889C1.84568 7.61111 1 8.4568 1 9.5V16.1111C1 17.1543 1.84568 18 2.88889 18Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(Icon);
